export default "__VITE_ASSET__CJSuaL4Q__"